const alphaFull = /^[0-9A-ZÁÉÍÓÚÑÀÈÌÒÙÇÜÄÖÜßČĎĚŇŘŠŤŮÝŽ/\-_.,\sºª]*$/i
export default {
  getMessage (field, args) {
    return field
  },
  validate (value, args) {
    return alphaFull.test(value)
  }
}
